import { createCustomAction } from "typesafe-actions";

const REPORT_DATA_LOAD = "REPORT/REPORT_DATA_LOAD";
const REPORT_DATA_LOAD_SUCCESS = "REPORT/REPORT_DATA_LOAD_SUCCESS";
const REPORT_DATA_LOAD_FAIL = "REPORT/REPORT_DATA_LOAD_FAIL";

export const load = createCustomAction(REPORT_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadSuccess = createCustomAction(
  REPORT_DATA_LOAD_SUCCESS,
  (type) => (data?: string) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  REPORT_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
